class BESSAppProjectWideProfilerItemData {

    constructor(fields, items) {
        this.name = 'Project wide';
        this.values = [];
        _.forEach(fields, function (field, i) {

            this.values.push(new BESSAppProjectProfilerItemMultiValueData(items, i));
        }.bind(this));
    }

    getEventIdentifier() {
        return 'project-wide';
    }
}

class BESSAppProjectProfilerItemMultiValueData extends BESSAppProjectProfilerItemValueData {

    constructor(items, fieldNo) {
        super({});
        this.valueCounts = {};
        let valuesMap = {};
        this.valueItems = {};
        _.forEach(items, function (item) {
            let value = item.values[fieldNo].value;
            if (!(value in this.valueCounts)) {
                this.valueCounts[value] = 1;
                valuesMap[value] = item.values[fieldNo];
                this.valueItems[value] = [];
            } else {
                this.valueCounts[value] += 1;
            }
            this.valueItems[value].push(item);
        }.bind(this));
        this.valueCounts = Object.fromEntries(Object.entries(this.valueCounts).sort((a, b) => b[1] - a[1]));
        this.values = [];
        _.forEach(this.valueCounts, function (valueCount, value) {

            let valueObj = valuesMap[value];
            valueObj.valueKey = value;
            this.values.push(valueObj);

        }.bind(this));

        this.value = this.values[0].value;
        this.isApplicable = true;
    }


    displayValue(field, emptyValue) {
        let displayValue = super.displayValue(field, emptyValue);
        if (displayValue !== '' && this.hasMultipleValues()) {
            let other = this.values.length - 1;
            displayValue += ' (and ' + other + (other > 1 ? " others" : " other") + ')';
        }

        return displayValue;
    }

    itemsForValue(value) {
        return this.valueItems[value.valueKey];
    }

    hasMultipleValues() {
        return this.values.length > 1;
    }
}